var map = {
	"./symbol_0.png": 60814,
	"./symbol_1.png": 60311,
	"./symbol_2.png": 52732,
	"./symbol_3.png": 88645,
	"./symbol_4.png": 18218,
	"./symbol_5.png": 50131,
	"./symbol_6.png": 38168,
	"./symbol_7.png": 75649
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42425;